<template>
  <v-toolbar :color="hasSelectedItems ? 'rgba(17, 138, 202, 0.1)' : undefined" elevation="0" style="border-radius: 8px;">
    <v-checkbox
      @change="handleCheckboxClick"
      :value="selectedAll"
      :indeterminate="indeterminate"
      :disabled="disabled"
      :label="label"
      color="primary"
      hide-details
    />
    <v-col v-if="hasSelectedItems" class="d-flex align-center" cols="9">
      <v-col cols="4" style="padding-left: 0">
        <div class="primary--text">{{ selectedConciliacaoLotesCount | pluralize }} de {{ totalConciliacaoLotes }}</div>
      </v-col>
    </v-col>
    <v-col v-if="hasSelectedItems" class="d-flex justify-center" cols="3">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on">
            <v-btn
            @click="() => $emit('action:desfazer-baixa-lotes')"
              :loading="loadingDesassociarLotes"
              color="primary"
              class="mr-2"
              :disabled="disableAcoes"
              small
              outlined
              v-bind="attrs"
            >
              Desfazer
            </v-btn>
          </div>
        </template>
        <span class="pa-5" v-if="disableAcoes">{{ this.mensagemTooltip }}</span>
      </v-tooltip>
    </v-col>
  </v-toolbar>
</template>

<script>
import { formatCurrency } from '../../../libs'

export default {
  props: {
    selectedConciliacaoLotes: Array,
    totalConciliacaoLotes: Number,
    loadingBaixaLotes: Boolean,
    loadingDesassociarLotes: Boolean,
    disableValorPendente: Boolean,
    disablePagamentoPublicado: Boolean,
    statusCount: Object,
  },
  computed: {
    selectedConciliacaoLotesCount () {
      return this.selectedConciliacaoLotes.length
    },
    selectedAll () {
      return this.selectedConciliacaoLotesCount > 0 && this.selectedConciliacaoLotesCount === this.totalConciliacaoLotes
    },
    indeterminate () {
      return this.selectedConciliacaoLotesCount > 0 && this.selectedConciliacaoLotesCount < this.totalConciliacaoLotes
    },
    disabled () {
      return this.totalConciliacaoLotes === 0
    },
    label () {
      return this.selectedConciliacaoLotesCount === 0 ? 'Selecionar todos os lotes' : undefined
    },
    hasSelectedItems () {
      return this.selectedConciliacaoLotesCount > 0
    },
    disableStatusCount () {
      return 'conciliacaoManual' in this.statusCount || 'conciliacaoAutomatica' in this.statusCount
    },
    disableAcoes () {
      return this.disableStatusCount || this.disablePagamentoPublicado || this.disableValorPendente
    },
    mensagemTooltip () {
      if (this.disablePagamentoPublicado) {
        return 'Pagamento já publicado'
      } else if (this.disableStatusCount) {
        return 'Pagamento em conciliacao Manual ou Automatica'
      } else if (this.disableValorPendente) {
        return 'Valores pendentes divergentes'
      }
      return ''
    }
  },
  methods: {
    handleCheckboxClick (checked) {
      if (checked) {
        this.$emit('change:select-all')
      } else {
        this.$emit('change:deselect-all')
      }
    }
  },
  filters: {
    pluralize (count) {
      if (count === 0) {
        return 'Nenhum lote selecionado'
      } else if (count === 1) {
        return '1 lote selecionado'
      } else {
        return `${count} lotes selecionados`
      }
    },
    formatCurrency (value) {
      return formatCurrency(value)
    }
  }
}
</script>
